import React, { Component } from "react";
import Headers from "../Layouts/Headers";
import DeliverySidebar from "../Layouts/DeliverySidebar";
import axios from "axios";
import $ from "jquery";
import { MDBTableEditable } from "../_mdbcomponents/components/pro/TableEditable/TableEditable";
import { MDBCard } from "../_mdbcomponents/components/Card/Card";
import { MDBCardHeader } from "../_mdbcomponents/components/Card/CardHeader/CardHeader";
import { MDBCardBody } from "../_mdbcomponents/components/Card/CardBody/CardBody";

export class PlacentaDelivery extends Component {
  constructor(props) {
    super(props);

   

    const url = "";
    this.state = {
      date: "",
      time: "",
      mode: "",
      indication: "",
      observation: "",
      loading: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    //this.PrintWindow = this.PrintWindow.bind(this);
    this.modal = true;
  }

  componentDidMount() {
    $(".obstudydone").on("click", function () {
      $(".obSoundDone").show();
    });
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  onTableChange(event) {}

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("currentVisitId"),
    };

    event.preventDefault();
    for (var i = 0; i < Object.keys(this.state.tablevaluesglobal).length; i++) {
      var dict = {
        mode: this.state.tablevaluesglobal[i]["mode"],
        indication: this.state.tablevaluesglobal[i]["indication"],
        observation: this.state.tablevaluesglobal[i]["observation"],
        date: this.state.date,
        time: this.state.time,
      };

      console.log(dict);
      this.setState({
        loading:true
      })
      axios
        .post(
          this.api_url+"delivery/placentadelivery",
          this.state,
          {
            headers: headers,
          }
        )
        .then((response) => {
          console.log(response);
          this.setState({
            loading:false
          })
          if (response.data["status"]) {
            $(".alert-success").show();
            setTimeout(function () {
              window.location.href = "/delivery/immediate/observation/mother";
            }, 500);
          }
        })
        .catch((error) => {
          $('#SubmitError').fadeIn();
          console.log(error);
        });
    }
  };

  handleTableChange(event) {
    console.log(event);
    this.setState({ myParentTrigger: this.state.myParentTrigger + "a" });
  }

  formatTableOutput(data) {
    let topobj = {};
    let tableobj = {};
    for (let i = 0; i < data.length; i++) {
      let trim = data[i];
      let trimobj = {};
      // mode:"",
      // indication:"",
      // observation:""
      trimobj.mode = data[i][0];
      trimobj.indication = data[i][1];
      trimobj.observation = data[i][2];
      tableobj[i] = trimobj;
      topobj.prepplan = tableobj;
    }
    this.state.tablevaluesglobal = topobj["prepplan"];
  }

  getTableValues(event) {
    console.log("entns");
    console.log(event);
    let tablevalues = this.formatTableOutput(event);
    console.log(tablevalues);
  }

  PrintWindow(event) {
    document.title =
      localStorage.getItem("currentVisitName") + "`s " + this.constructor.name;
    $(".modal").hide();
    window.print();
  }

  render() {
    const data = [
      ["Spontaneous", "", ""],
      ["Induced", "", ""],
      ["D&C", "", ""],
    ];
    const columns = ["Mode", "Indication", "Observation"];
    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };

    // {""1st":{"date""12/12/2022", "result":"good"}, "2nd":{"date":12/12/2022"","result":"good"}}

    const {
      date,
      time,
      loading
      // mode,
      // indication,
      // observation
    } = this.state;
    return (
      <div>
        <Headers />
        <DeliverySidebar />
        <main className="content-container">
          <div className="container p-2">
            <form onSubmit={this.handleSubmit}>
              <div className="py-1">
                <h6 className="text-capitalize" style={fontFamilyNunito}>
                  Date of Placenta Delivery
                </h6>
                <input
                  onChange={this.handleChange}
                  value={date}
                  name="date"
                  className="form-control"
                  type="date"
                />
              </div>
              <div className="py-1 mb-4">
                <h6 className="text-capitalize" style={fontFamilyNunito}>
                  Time
                </h6>
                <input
                  onChange={this.handleChange}
                  value={time}
                  name="time"
                  className="form-control"
                  type="time"
                />
              </div>

              <MDBCard>
                <MDBCardHeader
                  tag="h3"
                  className="text-center font-weight-bold text-capitalise py-4"
                >
                  Placenta Delivery
                </MDBCardHeader>
                <MDBCardBody>
                  <MDBTableEditable
                    onChange={(value) => this.handleTableChange(value)}
                    getValue={(value) => this.getTableValues(value)}
                    myParentTrigger={this.state.myParentTrigger}
                    id="#editablecard"
                    data={data}
                    columns={columns}
                    striped
                    bordered
                  />
                </MDBCardBody>
              </MDBCard>
              <div
                className="alert alert-danger"
                id="SubmitError"
                style={displayHidden}
                role="alert"
              >
                <strong> </strong>Something went wrong. Please try again
              </div>
              <div
                id="loginSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Details Saved Successfully.
              </div>

              <div className="row">
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                    {loading ? 'Loading' : 'Submit'}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default PlacentaDelivery;
